import React, { useEffect, useState, memo } from "react"
import Header from "../components/header/header"
import RelatedBlog from "../components/relatedBlog/relatedBlog"
import BlogDetailInfo from "../components/blogDetailInfo/blogDetailInfo"
import { useBlogMetaData } from "../queries/useBlogMetaData"
import { useLocation } from "@reach/router"
import Seo from "../components/seo"
import axios from "axios"
import parse from "html-react-parser"
import { graphql } from "gatsby"
import { blogSplitHTMLContent } from "../utils/functions"
import { Blog_Schema } from "../BlogSchema"
import BusinessForm from "../components/newComponents/businessForm/businessForm"
import Footer from "../components/newComponents/footer/footer"
import OurAlliance from "../components/newComponents/ourAlliance/ourAlliance"
import { useHomeNewMetadata } from "../queries/useHomeNewMetaData"

const BlogDetails = ({ data }) => {
  const {
    allWpPost: { edges },
    wpPost: {
      categories,
      singlePageFieldsNew,
      title,
      showFaqsSection,
      faqs,
      content: queryContent,
      featuredImage,
      date,
      databaseId,
    },
  } = data

  const { content, table_of_content } = blogSplitHTMLContent(queryContent)

  const homeData = useHomeNewMetadata()
  const blogData = useBlogMetaData()
  const [blogDetail, setBlogDetail] = useState([])
  const location = useLocation()
  const path = location?.pathname?.split("/")[2]

  const { generalSettingsUrl } = blogData?.wp?.allSettings

  const {
    relatedBlogsShowSection,
    relatedBlogsTitle,
    relatedBlogsSubTitle,
    relatedBlogsContent,

    homeAllianceSection,
    homeNewAllianceImageList,
    homeAllianceTitle,
    homeAllianceContent,
    homeAllianceSubTitle,
  } = homeData?.wpPage?.homePageNewFields

  useEffect(() => {
    axios({
      method: "get",
      url: `${process.env.GATSBY_API_URL}/wp-json/agile/v1/blogs/${path}`,
    }).then(function (response) {
      setBlogDetail(response?.data)
    })
  }, [path])

  useEffect(() => {
    localStorage.removeItem("casepage")
    localStorage.removeItem("blogpage")
  }, [])

  const blogSchema = {
    ...Blog_Schema,
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": data?.wpPost?.MetaFields?.customSeoOgUrl,
    },
    headline: data?.wpPost?.MetaFields?.customSeoMetaTitle,
    description: data?.wpPost?.MetaFields?.customSeoMetaDescription,
    image: featuredImage?.node?.mediaItemUrl,
    datePublished: date,
  }

  return (
    <>
      <Seo
        title={data?.wpPost?.seo?.title}
        seoData={data?.wpPost?.MetaFields}
        detail={blogDetail}
        bannerImage={featuredImage?.node?.mediaItemUrl}
        // This is particularly used for blog pages only
        blogSchema={blogSchema}
      />
      <Header headerClass="red-header new-header-bg" homeData={homeData?.wp} />

      {typeof window !== "undefined" ? (
        <BlogDetailInfo
          table_of_content={
            table_of_content
              ? table_of_content
              : blogDetail?.length
              ? blogDetail?.[0]?.table_of_content
              : ""
          }
          content={
            content
              ? content
              : blogDetail?.length
              ? blogDetail?.[0]?.content
              : ""
          }
          bannerData={blogDetail}
          generalSettingsUrl={generalSettingsUrl}
          blogImage={featuredImage?.node?.mediaItemUrl}
          blogImageAltTxt={featuredImage?.node?.altText}
          title={title}
          bannerDatas={blogDetail}
          categories={categories}
          singlePageFieldsNew={singlePageFieldsNew}
          databaseId={databaseId}
          viewsCountShowSection={singlePageFieldsNew.viewsCountShowSection}
          viewsCount={singlePageFieldsNew.viewsCount}
          showFaqsSection={showFaqsSection}
          faqs={faqs}
        />
      ) : queryContent ? (
        <div className="d-none">{parse(queryContent)}</div>
      ) : (
        ""
      )}
      <RelatedBlog
        relatedBlogsShowSection={relatedBlogsShowSection}
        relatedBlogsTitle={relatedBlogsTitle}
        relatedBlogsSubTitle={relatedBlogsSubTitle}
        relatedBlogsContent={relatedBlogsContent}
        blogList={edges}
      />

      <BusinessForm homeData={homeData?.wp} CustomClass="pt-110" />

      <OurAlliance
        homeAllianceSection={homeAllianceSection}
        homeAllianceImageList={homeNewAllianceImageList}
        homeAllianceTitle={homeAllianceTitle}
        homeAllianceContent={homeAllianceContent}
        homeAllianceSubTitle={homeAllianceSubTitle}
      />

      <Footer
        footerMenu={homeData?.wpMenu?.menuItems}
        homeData={homeData?.wp?.myThemeOptionsSettings}
      />
    </>
  )
}

export default memo(BlogDetails)

export const query = graphql`
  query BlogInfo($slug: String, $blogId: String, $categoryName: String) {
    wpPost(slug: { eq: $slug }) {
      slug
      title
      id
      uri
      date
      content
      databaseId
      categories {
        nodes {
          name
        }
      }
      singlePageFieldsNew {
        showFaqsSection
        faqs {
          faqListAnswer
          faqListQuestion
        }

        viewsCountShowSection
        viewsCount
        authorDesignation
        authorName
        showAuthor
        authorImage {
          mediaItemUrl
          altText
        }
      }
      featuredImage {
        node {
          mediaItemUrl
          altText
        }
      }
      MetaFields {
        customPageSchema
        customSeoFocusKeyphrase
        customSeoKeywords
        customSeoMetaDescription
        customSeoMetaTitle
        customSeoRobotFollow
        customSeoRobotIndex
        fieldGroupName
        customSeoOgUrl
      }
    }
    allWpPost(
      filter: {
        categories: { nodes: { elemMatch: { name: { eq: $categoryName } } } }
        id: { ne: $blogId }
      }
      limit: 3
      sort: { date: DESC }
    ) {
      edges {
        node {
          id
          title
          date
          slug
          content
          featuredImage {
            node {
              altText
              mediaItemUrl
            }
          }
        }
      }
    }
  }
`
